import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import styles from './Admin.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../Auth';
import AdminUsers from './Users/AdminUsers';
import SchemasList from './Schemas/SchemasList';
import DisabledBreedings from './DisabledBreedings/DisabledBreedings';
import { Accordion } from 'react-bootstrap';
import { general } from '../../../general';

function Admin(props: AdminProps) {
    const t = useTranslate();
    const navigate = useNavigate();
    const auth = useAuth();

    // Hvilken seksjon som er åpen ligger i URL-en, ikke i lokal state, slik at
    // «Brukere» fortsatt står åpen når man har vært inne på en bruker og trykker
    // tilbake. Seksjonsbodyen monteres først når seksjonen er åpen, så AdminUsers
    // remountes og henter sine egne lagrede filtre og sidetall.
    // replace: true holder åpning og lukking utenfor historikken.
    const areaKeys = ["0", "1", "2"];
    const [searchParams, setSearchParams] = useSearchParams();
    const areaParam = searchParams.get("area");
    const activeArea = areaParam != null && areaKeys.includes(areaParam) ? areaParam : undefined;

    function setActiveArea(key: any) {
        const params = new URLSearchParams(searchParams);
        if (key == null) {
            // Accordion sender null når man klikker på en åpen seksjon for å lukke den.
            params.delete("area");
        } else {
            params.set("area", key);
        }
        setSearchParams(params, { replace: true });
    }

    useEffect(() => {
        if (
            general.getBreedAccess(auth.user, auth.selectedBreed) == "dogowner" || 
            general.getBreedAccess(auth.user, auth.selectedBreed) == "user"
        ) {
            navigate("/");
        }
    }, [auth.user?.userdata?.ROLE, auth.selectedBreed]);

    return (
        <div className="maincontent">
            <div className={styles.admin}>
                <h1>{t("admin.title")}</h1>
                <hr/>
                <Accordion className={styles.accordion} activeKey={activeArea} onSelect={(k: any) => setActiveArea(k)}>
                    <Accordion.Item className={styles.accordionitem} eventKey="0">
                        <Accordion.Header className={styles.accordionheader}>{t("admin.areas.adminusers.title")}</Accordion.Header>
                        <Accordion.Body>
                            {activeArea == "0" &&
                                <AdminUsers />
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                    {auth.user?.userdata?.ROLE == "sysadmin" &&
                        <Accordion.Item className={styles.accordionitem} eventKey="1">
                            <Accordion.Header className={styles.accordionheader}>{t("admin.areas.schemaslist.title")}</Accordion.Header>
                            <Accordion.Body>
                                {activeArea == "1" &&
                                    <SchemasList />
                                }
                            </Accordion.Body>
                        </Accordion.Item>
                    }
                    <Accordion.Item className={styles.accordionitem} eventKey="2">
                        <Accordion.Header className={styles.accordionheader}>{t("admin.areas.disabledbreedings.title")}</Accordion.Header>
                        <Accordion.Body>
                            {activeArea == "2" &&
                                <DisabledBreedings />
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>
        </div>
    );
}

class AdminProps {
    
}

export default Admin;